export const configs: any = {
  local: {
    urls: {
      cloud: {
        ajax: {
          live: "/live/api/touch/",
          test: "/test/api/touch/",
          dev: "/dev/api/touch/",
          local: "/local/api/touch/",
        },
        api: {
          live: "/services-api-live/",
          test: "/services-api-test/",
          dev: "/services-api-dev/",
          local: "/services-api-local/",
        },
      },
      printables: "/hscloudsuite-printables/",
    },
  },
  default: {
    urls: {
      cloud: {
        ajax: {
          live: "https://api.hscloudsuite.com/api/touch/",
          test: "https://test-next.hscloudsuite.com/api/touch/",
          dev: "https://dev-next.hscloudsuite.com/api/touch/",
        },
        api: {
          live: "https://services-api.hscloudsuite.com/",
          test: "https://uat-service-api.hscloudsuite.com/",
          dev: "https://dev-services-api.hscloudsuite.com/",
        },
      },
      printables: "https://mobile.hscloudsuite.com/hscloudsuite-printables/",
    },
  },
};
